import SwiftMessageApi from '@/services/Api/SwiftMessageApi'

const state = () => ({
  swiftMessageTypes: [],
  loaded: false
})

const getters = {
  swiftMessageTypeOptions (state) {
    return state.swiftMessageTypes.map(type => ({
      name: type,
      value: String(type)
    }))
  },
  loaded (state) {
    return state.loaded
  }
}

const actions = {
  loadSwiftMessageTypes ({ commit }) {
    return SwiftMessageApi.fetchMessageTypes()
      .then(({ payload }) => {
        commit('setMessageTypes', payload)
        commit('setLoaded')
      })
  }
}

const mutations = {
  setMessageTypes (state, messageTypes) {
    state.swiftMessageTypes = messageTypes
  },
  setLoaded (state) {
    state.loaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
